import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_CONTRACT_TEMPLATES: createSagaAction('GET_CONTRACT_TEMPLATES')
}

// Action Creators
export const actions = {
  getContractTemplates: () => ({
    type: constants.GET_CONTRACT_TEMPLATES.ACTION
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_CONTRACT_TEMPLATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_CONTRACT_TEMPLATES.SUCCESS:
      return {
        ...state,
        contractTemplates: action.payload
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/contractTemplateActions.js